import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import {
  UserOutputDTO,
  UserByClientAppOutputDTO,
  UserByClientAppTableOutputDTO,
  UserByClientAppTableInputDTO,
  UserByClientAppTable2InputDTO,
} from './userDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class UserServices {
  async getById(id: number): Promise<UserOutputDTO | undefined> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/user/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async disableUserById(id: number): Promise<undefined> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_AUTH}/user/${id}`,
        { is_active: false },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByAll(): Promise<UserOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/user`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async userByClientApp(id: number): Promise<UserByClientAppOutputDTO[] | undefined> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/userByClientApp/user/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByIduserByClientApp(id: number): Promise<UserByClientAppTableOutputDTO | undefined> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/userByClientApp/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async putUserByClientApp(
    body: UserByClientAppTableInputDTO | UserByClientAppTable2InputDTO,
    id: number
  ): Promise<boolean> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_AUTH}/userByClientApp/${id}`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      if (res.status === 204) {
        return true
      }
      if (res.status === 200) {
        return true
      }
      return false
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async changePassword(userId: number, data: Object): Promise<any> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_AUTH}/user/self/${userId}`, data, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async recoverPassword(username: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/user/email/${username}`)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async loginByToken(token: string): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_AUTH}/user/jwt`, { token })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async changeLanguage(userId: number, data: Object): Promise<any> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_AUTH}/user/language/${userId}`, data, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async devicesByUserFilter(params: any): Promise<any> {
    try {
       const config: AxiosRequestConfig = {
         headers: { 'authentication-token': getJWT()! },
       }

       if (params) {
         config.params = params
       }
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/devices-by-user/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async removeDevicesByUser(id: number): Promise<any> {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL_AUTH}/devices-by-user/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async changeIsActiveDevices(id: number, body:any): Promise<any> {
    try{
      const res = await axios.put(`${process.env.REACT_APP_URL_AUTH}/devices-by-user/${id}`,body ,{
        headers: { 'authentication-token': getJWT()! }
      })
      return res.status
    }catch(error){
      throw error
    }
  } 
}

export const userServices = new UserServices()
